// Configuration dynamique basée sur l'environnement
const getBackendUrl = () => {
  // Si une variable d'environnement est définie, l'utiliser
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // Détection automatique basée sur l'URL actuelle
  const hostname = window.location.hostname;
  
  // Production Emergent
  if (hostname.includes('emergent.host')) {
    return window.location.origin; // Utilise le même domaine
  }
  
  // Preview Emergent
  if (hostname.includes('emergentagent.com')) {
    return window.location.origin;
  }
  
  // Domaine personnalisé
  if (hostname === 'gestiondestress.com') {
    return 'https://gestiondestress.com';
  }
  
  // Développement local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8001';
  }
  
  // Fallback: utiliser l'origine actuelle
  return window.location.origin;
};

const config = {
  backendUrl: getBackendUrl(),
  apiUrl: `${getBackendUrl()}/api`,
};

export default config;
